var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 185,
    viewBox: "0 0 187 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.6078,
    cy: 162.321,
    rx: 58.5953,
    ry: 10.1526,
    fill: "url(#paint0_radial_14011_169617)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4126 118.715C41.873 122.85 36.4631 124.145 32.3268 121.607C28.1904 119.068 26.8945 113.658 29.4331 109.522C31.9737 105.387 51.2842 81.4453 55.4195 83.983C59.5552 86.5224 46.9496 114.579 44.4126 118.715Z",
    fill: "#DB1375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.5177 116.996C40.651 120.035 36.674 120.988 33.6323 119.123C30.5928 117.256 29.6415 113.279 31.5072 110.239C33.3736 107.199 47.5681 89.6024 50.6073 91.4674C53.6484 93.3335 44.3834 113.956 42.5177 116.996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3441 105.23C43.3441 100.257 43.6569 95.744 44.2755 91.6545C43.323 92.6407 42.3589 93.676 41.403 94.7298C40.9677 98.4704 40.7494 102.512 40.7494 106.876C40.7494 111.556 41.1684 116.425 41.9399 121.326C42.9239 120.65 43.7864 119.764 44.4517 118.681C44.4576 118.672 44.4646 118.658 44.4727 118.648C43.7421 114.098 43.3441 109.575 43.3441 105.23Z",
    fill: "#B21F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.45 118.714C144.987 122.85 150.4 124.145 154.535 121.607C158.67 119.068 159.967 113.657 157.427 109.522C154.887 105.388 135.577 81.4456 131.443 83.983C127.308 86.5227 139.911 114.578 142.45 118.714Z",
    fill: "#DB1375"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.346 116.996C146.213 120.035 150.191 120.987 153.229 119.123C156.27 117.256 157.222 113.279 155.357 110.24C153.49 107.199 139.294 89.6021 136.254 91.4677C133.216 93.3336 142.481 113.956 144.346 116.996Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.518 105.23C143.518 100.257 143.206 95.744 142.584 91.6545C143.538 92.6407 144.504 93.676 145.459 94.7298C145.893 98.4704 146.114 102.512 146.114 106.876C146.114 111.556 145.691 116.425 144.921 121.326C143.937 120.65 143.076 119.764 142.411 118.681C142.406 118.672 142.396 118.658 142.389 118.648C143.119 114.098 143.518 109.575 143.518 105.23Z",
    fill: "#B21F5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.851 67.9276C132.769 71.5582 127.446 72.8179 125.96 70.7415C124.478 68.6634 127.393 64.0371 132.476 60.4058C137.558 56.7735 142.88 55.5128 144.365 57.5906C145.851 59.666 142.933 64.2937 137.851 67.9276Z",
    fill: "#DB1375"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.623 77.7908C129.375 77.7664 124.32 75.6773 124.33 73.1237C124.34 70.5713 129.413 68.5219 135.659 68.5463C141.906 68.5708 146.962 70.6599 146.951 73.2134C146.941 75.7659 141.87 77.8153 135.623 77.7908Z",
    fill: "#DB1375"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.418 59.3184C120.42 65.2352 120.757 70.6956 123.177 71.5134C125.597 72.3287 129.178 68.1943 131.178 62.2782C133.176 56.3599 132.839 50.8995 130.418 50.0828C127.998 49.2664 124.416 53.4001 122.418 59.3184Z",
    fill: "#DB1375"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6902 67.9274C53.7711 71.5574 59.0949 72.8177 60.5808 70.7423C62.0636 68.6632 59.1478 64.0369 54.0651 60.4056C48.9821 56.7726 43.6609 55.5127 42.1753 57.5897C40.6903 59.6658 43.6079 64.2935 48.6902 67.9274Z",
    fill: "#DB1375"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9171 77.7909C57.1651 77.7665 62.2214 75.6774 62.2102 73.1238C62.2002 70.5714 57.1289 68.522 50.8809 68.5464C44.6341 68.5709 39.5778 70.66 39.589 73.2135C39.599 75.766 44.6703 77.8154 50.9171 77.7909Z",
    fill: "#DB1375"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1197 59.3177C66.1175 65.236 65.7807 70.6952 63.3613 71.5128C60.9415 72.3293 57.3596 68.1943 55.361 62.2775C53.3632 56.3593 53.7001 50.9 56.1198 50.0836C58.5392 49.266 62.1208 53.3999 64.1197 59.3177Z",
    fill: "#DB1375"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.821 104.083C143.821 70.503 126.854 62.0369 93.2695 62.0369C59.6881 62.0369 42.7194 70.503 42.7194 104.083C42.7194 128.218 57.3864 158.946 70.8255 159.094C81.5835 159.212 80.6766 151.03 93.2695 151.049C105.699 151.07 104.254 159.92 114.064 159.844C131.082 159.711 143.821 130.36 143.821 104.083Z",
    fill: "#DB1375"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.434 74.5843C142.441 72.5198 138.624 70.8053 133.712 70.566C133.989 70.3863 134.267 70.1961 134.542 70C138.951 66.8523 141.479 62.8387 140.192 61.0367C138.905 59.2359 134.288 60.3294 129.881 63.4783C129.605 63.6755 129.338 63.8762 129.077 64.0793C130.442 59.3561 130.057 55.1895 128.098 54.529C126 53.8194 122.896 57.4059 121.16 62.5364C119.427 67.6681 119.722 72.4019 121.819 73.1103C122.536 73.3531 123.373 73.0928 124.23 72.4392L124.234 72.4427C123.354 73.0333 122.843 73.7254 122.821 74.4665C115.736 71.4215 105.938 70.7586 93.2702 70.7586C80.9761 70.7586 71.3841 71.383 64.3541 74.2039C64.2327 73.5631 63.7425 72.9633 62.9686 72.4439C62.9686 72.4439 62.9709 72.4427 62.9709 72.4416C62.9709 72.4416 62.9733 72.4404 62.9733 72.4392C63.83 73.0928 64.6669 73.3531 65.3847 73.1103C67.4833 72.4019 67.7763 67.6681 66.043 62.5364C64.3085 57.4059 61.2038 53.8194 59.1052 54.529C57.149 55.1895 56.7626 59.3561 58.1259 64.0793C57.8668 63.8762 57.5983 63.6755 57.3229 63.4783C52.9155 60.3294 48.3004 59.2359 47.0118 61.0367C45.7256 62.8387 48.2549 66.8523 52.6611 70C52.9365 70.1961 53.2143 70.3863 53.4898 70.566C48.5782 70.8053 44.7627 72.5198 44.7697 74.5843C44.7778 76.7983 49.177 78.5758 54.5951 78.5548C55.6246 78.5501 56.6167 78.4824 57.5505 78.3576C52.1323 83.2874 49.5038 91.31 49.5038 104.266C49.5038 134.1 63.4355 150.526 93.2702 150.526C123.105 150.526 137.037 134.1 137.037 104.266C137.037 91.2026 134.365 83.1543 128.857 78.2339C130.012 78.4358 131.279 78.5478 132.611 78.5548C138.026 78.5758 142.424 76.7983 142.434 74.5843Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 93.2349,
    cy: 104.976,
    rx: 47.0616,
    ry: 43.9343,
    fill: "url(#paint1_radial_14011_169617)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2594 107.999C78.5586 107.999 66.9975 98.474 61.8572 90.0978C64.4752 98.46 76.7378 111.386 93.2594 111.386C109.653 111.386 122.092 98.3643 124.683 90.0044C119.519 98.404 107.847 107.999 93.2594 107.999Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2594 107.552C78.5586 107.552 66.9975 98.0282 61.8572 89.6508C64.4752 98.0142 76.7378 110.941 93.2594 110.941C109.653 110.941 122.092 97.9173 124.683 89.5586C119.519 97.9582 107.847 107.552 93.2594 107.552Z",
    fill: "#6D0F0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.376 64.3343C125.376 81.6388 111.003 95.6685 93.269 95.6685C75.5381 95.6685 61.1617 81.6388 61.1617 64.3343C61.1617 47.0297 75.5381 33.0001 93.269 33.0001C111.003 33.0001 125.376 47.0297 125.376 64.3343Z",
    fill: "#DB1375"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.638 63.8861C120.638 79 108.385 91.2522 93.27 91.2522C78.1549 91.2522 65.9016 79 65.9016 63.8861C65.9016 48.7722 78.1549 36.52 93.27 36.52C108.385 36.52 120.638 48.7722 120.638 63.8861Z",
    fill: "url(#paint2_radial_14011_169617)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.688 63.8847C112.688 74.6064 103.995 83.2981 93.2726 83.2981C82.5499 83.2981 73.8574 74.6064 73.8574 63.8847C73.8574 53.1629 82.5499 44.4712 93.2726 44.4712C103.995 44.4712 112.688 53.1629 112.688 63.8847Z",
    fill: "url(#paint3_radial_14011_169617)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.351 63.8851C102.351 68.9013 98.2858 72.9663 93.2692 72.9663C88.2526 72.9663 84.1873 68.9013 84.1873 63.8851C84.1873 58.8701 88.2526 54.804 93.2692 54.804C98.2858 54.804 102.351 58.8701 102.351 63.8851Z",
    fill: "#49482A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.64 132.458C120.64 140.193 108.387 146.463 93.2714 146.463C78.1586 146.463 65.903 140.193 65.903 132.458C65.903 124.726 78.1586 118.455 93.2714 118.455C108.387 118.455 120.64 124.726 120.64 132.458Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.2687,
    cy: 54.2949,
    rx: 10.8089,
    ry: 8.30446,
    fill: "url(#paint4_radial_14011_169617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_169617",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.6078 162.321) rotate(90) scale(10.1526 58.5953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_169617",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.2349 100.525) rotate(90) scale(48.3004 44.1667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C57730",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_169617",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.2704 63.8858) scale(27.3684 27.3661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_169617",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.2722 63.885) scale(19.4152 19.4135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9757EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_169617",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.2687 71.7798) rotate(-90) scale(25.7893 33.5667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster3);
export default __webpack_public_path__ + "static/media/Monster3.78568b231df23ecc087385d386a5cdb1.svg";
export { ForwardRef as ReactComponent };